import api from '@/api/submission'

const state = {
  submissions: [],
  currentSubmission: null,
  total: 0,
  loading: false
}

const getters = {
  allSubmissions: state => state.submissions,
  currentSubmission: state => state.currentSubmission,
  submissionsTotal: state => state.total,
  isLoading: state => state.loading
}

const mutations = {
  SET_SUBMISSIONS(state, { submissions, total }) {
    state.submissions = submissions
    state.total = total
  },
  SET_CURRENT_SUBMISSION(state, submission) {
    state.currentSubmission = submission
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  UPDATE_SUBMISSION(state, updatedSubmission) {
    const index = state.submissions.findIndex(
      s => s._id === updatedSubmission._id
    )
    if (index !== -1) {
      state.submissions.splice(index, 1, updatedSubmission)
    }
  }
}

const actions = {
  async fetchSubmissions({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      const response = await api.list(params)
      commit('SET_SUBMISSIONS', {
        submissions: response.data.items,
        total: response.data.total
      })
      return response.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchSubmission({ commit }, id) {
    commit('SET_LOADING', true)
    try {
      const response = await api.getById(id)
      commit('SET_CURRENT_SUBMISSION', response.data)
      return response.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateStatus({ commit }, { id, status, notes }) {
    const response = await api.updateStatus(id, { status, notes })
    commit('UPDATE_SUBMISSION', response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
